export default {
  title: '營銷活動',
  activityManagement: '活動管理',
  activityList: '活動列表',
  drawRecord: '開獎記錄',
  giftClaimRecord: '禮品領取記錄',
  activityTemplate: '活動模板',
  marketingData: '營銷數據',
};
